/* eslint-disable jira/filename-case */
import type { EntityLimits } from './EntityLimitType.types.tsx';
import type { State } from './State.types.tsx';

export const getEntityLimits = (state: State): EntityLimits | null => state?.entityLimits ?? null;
